var map = {
	"./about-us.tsx": 73327,
	"./access-level.tsx": 53740,
	"./add-article.tsx": 58043,
	"./add-news.tsx": 88380,
	"./add-project.tsx": 1406,
	"./add-users.tsx": 81745,
	"./article-list.tsx": 92272,
	"./catalog-list.tsx": 83593,
	"./catalog.tsx": 3002,
	"./change-password.tsx": 71925,
	"./contact-us.tsx": 36669,
	"./cooperation-page.tsx": 83292,
	"./cooperation-req.tsx": 15176,
	"./dashboard-page.tsx": 74982,
	"./departments.tsx": 33994,
	"./faq-page.tsx": 77927,
	"./forgot-password.tsx": 21058,
	"./links.tsx": 31633,
	"./login-page.tsx": 3461,
	"./news-list.tsx": 37169,
	"./notification.tsx": 77914,
	"./page_detaile.tsx": 27027,
	"./profile.tsx": 68060,
	"./project-list.tsx": 80523,
	"./register-page.tsx": 47922,
	"./slider-management.tsx": 92134,
	"./user-grouping.tsx": 73096,
	"./website-information.tsx": 85941
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 54640;